/**
 * ============================================================
 * Export Utility
 * ============================================================
 */

class TrackExport {
    toGeoJSON(track) {
        const points = track.points;

        const start = points[0];

        const end = points[points.length - 1];

        // ==========================================
        // Features dasar
        // ==========================================

        const features = [
            // ==========================
            // Track
            // ==========================

            {
                type: "Feature",

                properties: {
                    feature: "track",

                    name: track.name,

                    distance: Number(track.distance.toFixed(2)),

                    duration: track.duration,

                    average_speed: Number(track.averageSpeed.toFixed(2)),

                    point_count: points.length,

                    started: track.startTime,

                    finished: track.endTime,

                    application: "Mining Survey WebGIS",

                    version: "0.5.1",
                },

                geometry: {
                    type: "LineString",

                    coordinates: points.map((point) => [point.longitude, point.latitude, point.altitude ?? 0]),
                },
            },

            // ==========================
            // Start
            // ==========================

            {
                type: "Feature",

                properties: {
                    feature: "start",

                    name: "Start",
                },

                geometry: {
                    type: "Point",

                    coordinates: [start.longitude, start.latitude, start.altitude ?? 0],
                },
            },

            // ==========================
            // Finish
            // ==========================

            {
                type: "Feature",

                properties: {
                    feature: "end",

                    name: "Finish",
                },

                geometry: {
                    type: "Point",

                    coordinates: [end.longitude, end.latitude, end.altitude ?? 0],
                },
            },
        ];

        // ==========================================
        // Waypoint
        // ==========================================

        (track.waypoints ?? []).forEach((waypoint) => {
            features.push({
                type: "Feature",

                properties: {
                    feature: "waypoint",

                    name: waypoint.name,

                    description: waypoint.description,

                    accuracy: waypoint.accuracy,

                    altitude: waypoint.altitude,

                    heading: waypoint.heading,

                    speed: waypoint.speed,

                    timestamp: waypoint.timestamp,
                },

                geometry: {
                    type: "Point",

                    coordinates: [waypoint.longitude, waypoint.latitude, waypoint.altitude ?? 0],
                },
            });
        });

        // ==========================================
        // Return
        // ==========================================

        return {
            type: "FeatureCollection",

            features,
        };
    }

    downloadGeoJSON(track, filename) {
        const geojson = this.toGeoJSON(track);

        const blob = new Blob(
            [JSON.stringify(geojson, null, 2)],

            {
                type: "application/geo+json",
            },
        );

        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");

        link.href = url;

        link.download = filename;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    }
}

export default new TrackExport();
